var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnWeb3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.365.32a2.54 2.54 0 0 0-2.479.006l9.112 8.406L14.06 5.67 4.365.32zm-3.39.866a2.33 2.33 0 0 0-.35 1.221V17.59c0 .427.116.835.326 1.191l9.163-9.163-9.139-8.43zm17.143 6.725L15.198 6.3l-3.281 3.28 4.02 3.708 2.182-1.204c.785-.435 1.255-1.215 1.255-2.087-.001-.873-.47-1.653-1.256-2.086zm-7.085 2.553-9.188 9.188c.399.228.836.348 1.276.348.425 0 .853-.108 1.244-.324l10.42-5.75-3.752-3.462z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnWeb3);
export default __webpack_public_path__ + "static/media/icn_web_3.912dd7d83a0b22682f3602b1e0c0bcf1.svg";
export { ForwardRef as ReactComponent };